import React, { useRef, useState } from "react";

import SuiButton from "components/SuiButton";
import Card from "@mui/material/Card";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import Icon from "@mui/material/Icon";
import CancelIcon from "@mui/icons-material/Cancel";

import ReactPlayer from "react-player";

const MediaCard = ({ type = "image", src, className, onDelete, style = {} }) => {
  const [visible, setVisible] = useState(false);
  const [isHover, setIsHover] = useState(false);

  return (
    <div onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
      {type == "video" ? (
        <div
          className={`relative w-48 h-64 rounded-xl overflow-hidden shadow-lg hover:cursor-pointer ${
            className ? className : ""
          }`}
          style={{ ...style }}
        >
          <Card
            className="w-48 h-64 bg-transparent"
            onClick={() => setVisible(true)}
            style={{ zIndex: 999, opacity: 0 }}
          ></Card>
          <ReactPlayer
            url={src}
            height="100%"
            width="100%"
            style={{ zIndex: 2, position: "absolute", top: 0, left: 0 }}
          />

          {isHover && onDelete ? (
            <CancelIcon
              style={{ zIndex: 1999 }}
              className="absolute top-1 right-1 h-6 w-6 hover:cursor-pointer"
              color="error"
              onClick={onDelete}
            ></CancelIcon>
          ) : null}
        </div>
      ) : (
        <div
          className={`shadow-lg flex items-center rounded-xl snap-start  block bg-origin-padding bg-left-top bg-cover hover:cursor-pointer ${className}`}
          style={{
            zIndex: 0,
            position: "relative",
            width: "12rem",
            height: "16rem",
            overflow: "hidden",
            ...style,
          }}
        >
          <div style={{ position: "relative", display: "inline-block", right: "-50%" }}>
            <img
              src={src}
              onClick={() => setVisible(true)}
              style={{ position: "relative", height: "16rem", left: "-50%", ...style }}
            />
          </div>
          {isHover && onDelete ? (
            <CancelIcon
              className="absolute top-1 right-1 h-6 w-6 hover:cursor-pointer"
              color="error"
              onClick={onDelete}
            ></CancelIcon>
          ) : null}
        </div>
      )}

      {visible ? (
        <Dialog open={visible} maxWidth={"md"}>
          <DialogTitle sx={{ mb: 1, p: 2 }}>
            <IconButton
              aria-label="close"
              onClick={() => setVisible(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            {" "}
            {type == "video" ? (
              <div style={{ width: "auto", height: "100%" }}>
                <ReactPlayer url={src} controls />
              </div>
            ) : (
              <img
                src={src}
                style={{ width: "100%", height: "auto" }}
                className="snap-start shadow-lg relative block bg-origin-padding bg-left-top bg-cover"
              ></img>
            )}
          </DialogContent>
        </Dialog>
      ) : null}
    </div>
  );
};

export default MediaCard;
